export default __webpack_public_path__ + "static/media/Helvetica-Light.ad13c7b0.woff";